import type * as Style from '../../index.js'
import { ColorReference, Keyword } from '../../values/index.js'
import { fixReference as fixColorReference } from '../basic/color.js'
import { Set } from '../../index.js'

export enum LinkDecorationStyle {
  'underline' = 'underline',
  'dotted' = 'dotted',
  'double' = 'double',
  'none' = 'none'
}

export const Props = (props: any = {}) => ({
  textColor: ColorReference(props.textColor),
  linkDecoration: Keyword<LinkDecorationStyle>(props.linkDecoration, LinkDecorationStyle)
})
export const fix = (props: Props, styles: Style.Rule[]): Props => ({
  ...props,
  textColor: fixColorReference(props.textColor, styles)
})

export type Props = ReturnType<typeof Props>
export const validate = () => true
export const type = 'palette'
export const label = 'Text color'
export const property = 'paletteIds'
export const category = 'aspect'
export const forms = [
  {
    label: 'Text color',
    id: 'palette',
    extractProperties: Props,
    validate: () => true
  }
]
export const summarize = (props: Props, styles?: Style.Rule[], formId?: string) => {
  const color = Set.findByTypeAndId(styles || [], 'color', props.textColor.id)
  switch (formId) {
    case 'palette':
      return color ? `rgba(${color.props.red}, ${color.props.green}, ${color.props.blue}, ${color.props.alpha})` : 'None'
    default:
      return color ? `${color.details.title}` : props.textColor.id
  }
}
